export const members = [
  {
    id: 1,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-12.webp',
    name: 'Albert Flores',
    email: 'tanya.hill@example.com',
    color: 'text-[#00a76f]',
    fill: 'bg-[#00a76f]/10',
    status: 'online',
  },
  {
    id: 2,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-11.webp',
    name: 'Jenny Wilson',
    email: 'michael.mitc@example.com',
    color: 'text-[#00b8d9]',
    fill: 'bg-[#00b8d9]/10',
    status: 'online',
  },
  {
    id: 3,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-10.webp',
    name: 'Bessie Cooper',
    email: 'curtis.weaver@example.com',
    color: 'text-[#ff5630]',
    fill: 'bg-[#ff5630]/10',
    status: 'busy',
  },
  {
    id: 4,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-07.webp',
    name: 'Wade Warren',
    email: 'debra.holt@example.com',
    color: 'text-[#00a76f]',
    fill: 'bg-[#00a76f]/10',
    status: 'away',
  },
  {
    id: 5,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-02.webp',
    name: 'Robert Fox',
    email: 'michael.mitc@example.com',
    color: 'text-[#00b8d9]',
    fill: 'bg-[#00b8d9]/10',
    status: 'busy',
  },
  {
    id: 6,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-14.webp',
    name: 'Sungla hass',
    email: 'sungla@example.com',
    color: 'text-[#ff5630]',
    fill: 'bg-[#ff5630]/10',
    status: 'online',
  },
  {
    id: 7,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-03.webp',
    name: 'Shoeie Fashio',
    email: 'fashio@example.com',
    color: 'text-[#00a76f]',
    fill: 'bg-[#00a76f]/10',
    status: 'offline',
  },
  {
    id: 8,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-13.webp',
    name: 'fume lueak',
    email: 'lueak@example.com',
    color: 'text-[#00b8d9]',
    fill: 'bg-[#00b8d9]/10',
    status: 'away',
  },
];
